import React from "react";
import PartyPage from "@/pages/PartyPage";
export default function Customers() { return <PartyPage kind="customers" />; }
